export const paymentFields = {
  paid_amount: {
    fieldPath: 'paid_amount',
    fieldReadPath: 'paid_amount',
    name: 'paid_amount',
    label: 'global.paid_amount.label',
    options: [],
    id: 'global__paid-amount',
    veeValidation: true,
    rules: ['required', 'numeric', 'payment_less_or_equal_invoice_balance'],
    warningRules: [],
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
  },
  payment_date: {
    fieldPath: 'payment_date',
    fieldReadPath: 'payment_date',
    name: 'payment_date',
    label: 'global.payment_date.label',
    options: [],
    id: 'global__payment_date',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  payment_time: {
    fieldPath: 'payment_time',
    fieldReadPath: 'payment_time',
    name: 'payment_time',
    label: 'global.payment_time.label',
    options: [],
    id: 'global__payment_time',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },

  payment_method_type: {
    fieldPath: 'payment_method_type',
    fieldReadPath: 'payment_method_type',
    name: 'payment_method_type',
    label: 'global.payment_method_type.label',
    options: [
      {
        text: 'global.payment.cash',
        value: 'cash',
      },
      {
        text: 'global.payment.wipay_terminal',
        value: 'wipay_terminal',
        module: 'payment_terminals',
      },
      {
        text: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        text: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        text: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        text: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      // {
      //   text: 'global.payment.stripe',
      //   value: 'stripe',
      // },
      // {
      //   text: 'global.payment.bancontact',
      //   value: 'bancontact',
      // },
      // {
      //   text: 'global.payment.cashdro',
      //   value: 'cashdro',
      // },
    ],
    id: 'global__payment-method-type',
    veeValidation: true,
    rules: [
      'required',
      'in:cash,wipay_terminal,money_transfer,debit_card,credit_card,cheque,sport_cheque,stripe,paypal,bancontact,sodexo_cheque,cashdro',
    ],
    warningRules: [],
  },
};

export const paymentDisplayFields = {
  payment_method_type: {
    sortable: true,
    valueToLabel: [
      { value: 'cash', label: 'accounting.payments.payment_method_type.cash.label' },
      {
        value: 'money_transfer',
        label: 'accounting.payments.payment_method_type.money_transfer.label',
      },
      { value: 'debit_card', label: 'accounting.payments.payment_method_type.debit_card.label' },
      { value: 'credit_card', label: 'accounting.payments.payment_method_type.credit_card.label' },
      { value: 'cheque', label: 'accounting.payments.payment_method_type.cheque.label' },
      {
        value: 'sport_cheque',
        label: 'accounting.payments.payment_method_type.sport_cheque.label',
      },
      { value: 'stripe_card', label: 'accounting.payments.payment_method_type.stripe.label' },
      { value: 'paypal', label: 'accounting.payments.payment_method_type.paypal.label' },
      { value: 'cashdro', label: 'accounting.payments.payment_method_type.cashdro.label' },
      { value: 'clearance', label: 'accounting.payments.payment_method_type.clearance.label' },
    ],
    toTranslate: true,
    order: 40,
  },
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'waiting', label: 'global.status.waiting' },
      { value: 'ongoing', label: 'global.status.ongoing' },
      { value: 'paid', label: 'global.status.paid' },
      { value: 'cancelled', label: 'global.status.cancelled' },
      { value: 'timer_expired', label: 'global.status.timer_expired' },
    ],
    valueToVariant: [
      { value: 'waiting', variant: 'warning' },
      { value: 'ongoing', variant: 'warning' },
      { value: 'paid', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
      { value: 'timer_expired', variant: 'danger' },
    ],
  },
};
